import { useEffect } from "react";

function upsertMeta(selector, attributes, content) {
    if (!content) return;
    let element = document.head.querySelector(selector);
    if (!element) {
        element = document.createElement("meta");
        Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
        document.head.appendChild(element);
    }
    element.setAttribute("content", content);
}

function upsertLink(selector, attributes, href) {
    if (!href) return;
    let element = document.head.querySelector(selector);
    if (!element) {
        element = document.createElement("link");
        Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
        document.head.appendChild(element);
    }
    element.setAttribute("href", href);
}

export default function useDocumentMeta({ title, description, canonicalPath, robots }) {
    useEffect(() => {
        if (title) {
            document.title = title;
            upsertMeta('meta[property="og:title"]', { property: "og:title" }, title);
            upsertMeta('meta[name="twitter:title"]', { name: "twitter:title" }, title);
        }

        if (description) {
            upsertMeta('meta[name="description"]', { name: "description" }, description);
            upsertMeta('meta[property="og:description"]', { property: "og:description" }, description);
            upsertMeta('meta[name="twitter:description"]', { name: "twitter:description" }, description);
        }

        if (robots) {
            upsertMeta('meta[name="robots"]', { name: "robots" }, robots);
        }

        if (canonicalPath) {
            const canonicalUrl = new URL(canonicalPath, window.location.origin).toString();
            upsertLink('link[rel="canonical"]', { rel: "canonical" }, canonicalUrl);
            upsertMeta('meta[property="og:url"]', { property: "og:url" }, canonicalUrl);
        }
    }, [title, description, canonicalPath, robots]);
}

